export default class Question {
  id = 0
  question = ''
  subQuestion = ''
  type = ''
  section = ''
  page = 0
  validations = []
  values = []
  relatesTo = ''

  constructor (rawData = {}) {
    this.id = rawData.id
    this.question = rawData.question
    if (rawData.sub_question !== undefined) {
      this.subQuestion = rawData.sub_question
    }
    this.type = rawData.type
    this.section = rawData.section
    this.page = rawData.page
    this.validations = rawData.validations
    this.values = rawData.values
    this.relatesTo = rawData.relates_to
  }
}
